import api from "./api";

export const getAllLevel3Resources = async (
  params: { parentId?: string } = {}
) => {
  const { data } = await api.get("/admin/level3Resources", { params });
  return data.level3Resources ?? [];
};
